import { useState, useEffect } from "react";
import { getAllLocations } from "services/locationService";

const LocationLinks = () => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      const data = await getAllLocations();
      const activeLocations = data.filter((loc) => loc.active === true);
      setLocations(activeLocations);
    };
  
    fetchLocations();
  }, []);

  return (
    <div className="mt-4 backdrop-blur-md rounded-sm w-full text-left">
      <h3 className="text-lg font-semibold text-gray-400 mb-4 border-b border-amber-400 pb-2">
        S'inscrire aux hebdos
      </h3>
      <ul>
        {[...locations].map((location) => (
          <li key={location.id}>
            <a
              href={`/locations/${location.id}`}
              className="block p-2 bg-opacity-70 hover:bg-amber-500 hover:text-white transition duration-200 text-white text-sm shadow-xl"
            >
              {location.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LocationLinks;
